import {Component, OnInit} from '@angular/core';
import {I18nHelperService, ApiService} from '@xref/ngx';
import {MaintenanceService} from './services/maintenance/maintenance.service';
import { RouteChangeService } from './services/route-change/route-change.service';
import { RouterOutlet } from '@angular/router';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { routerAnimations } from './shared/router-animations';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthService } from './services/auth/auth.service';
import { Title } from '@angular/platform-browser';
import constants from './shared/constants';
import * as Cookie from 'js-cookie';
import { filter, map } from 'rxjs/operators';

import { environment } from '../environments/environment';
import Constants from './shared/constants';

@Component({
    selector: 'xqnr-app',
    templateUrl: './app.component.pug',
    styleUrls: ['./app.component.scss'],
    animations: [
        routerAnimations
    ],
    standalone: false
})
export class AppComponent implements OnInit {
  loaded = false;
  contrast = false;
  title = 'Build a Reference Check Template Free - Xref';

  constructor(
    private api: ApiService,
    public maintenance: MaintenanceService,
    private i18nHelper: I18nHelperService,
    private routeChange: RouteChangeService,
    private jwtHelper: JwtHelperService,
    private auth: AuthService,
    private titleService: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.api.config.errorResponseHandler = this.apiErrorResponseHandler;

    this.i18nHelper.init();

    this.loaded = true;
    this.contrast = false;

    this.routeChange.scrollToTop();
    this.showContrastMode();

    // Deletes expires tokens to avoid errors
    this.checkForExpiredToken();

    const appTitle = this.titleService.getTitle();
    this.router
      .events.pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          const child = this.activatedRoute.firstChild;
          if (child.snapshot.data['title']) {
            return child.snapshot.data['title'];
          }
          return appTitle;
        })
      ).subscribe((ttl: string) => {
        this.titleService.setTitle(ttl);
      });
  }

  prepareRoute(outlet: RouterOutlet): string {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }

  showContrastMode() {
    this.contrast = Cookie.get(Constants.CONTRAST) === 'true';
  }

  highContrastChange(contrast: boolean) {
    this.contrast = contrast;
    Cookie.set(Constants.CONTRAST, this.contrast, {domain: environment.DOMAIN});
  }

  apiErrorResponseHandler = (err: any) => {
    switch (err.status) {
      case 429:
      case 503:
        // Remove token and set maintenance mode
        this.maintenance.setMaintenance();
        this.loaded = true;
        break;
    }
  };

  // On every page load check for an expired token and if it is then delete it
  checkForExpiredToken() {
    const token = Cookie.get(constants.QUESTIONNAIRE_TOKEN);

    if (token != undefined) {
      if (this.jwtHelper.isTokenExpired(token)) {
        this.auth.removeToken();
      }
    }
  }
}
